// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4149":"css/app.6958","4653":"css/admin-app.6958"}[chunkId] + ".css";
};